import React from 'react';
import { ACCENT_COLOR } from './colors';

const AbstractRight = ({
  width = 296,
  className = '',
}) => (
  <svg
    className={`svg-icon ${className || ''}`}
    width={width}
    height={width / 0.9517684887459807}
    viewBox="0 0 296 311"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path d="M42 276L316 2" stroke="#E5E5E6" strokeWidth="2" strokeLinecap="square" />
    <path d="M2 336L246 92" stroke="#E5E5E6" strokeWidth="2" strokeLinecap="square" />
    <path d="M132 226L326 32" stroke="#E5E5E6" strokeWidth="2" strokeLinecap="square" />
    <path d="M76 176L161 91L246 176L161 261L76 176Z" stroke="#FFCC66" strokeWidth="20" />
    <circle cx="211" cy="231" r="30" fill={ACCENT_COLOR} />
  </svg>
);

export default AbstractRight;
